angular.module('agreements')
    .controller('AgreementProcessingController', function (data, $uibModalInstance, Agreement) {
        this.$onInit = () => {
            Agreement.history({id: data}).$promise.then(items => this.items = items)
        }
        this.close = () => $uibModalInstance.dismiss()
    })
